import { Observable } from 'rxjs/Observable';
import { BaseController } from '../../../core/controllers/base.controller';
import { SearchResultModel } from './search-result.model';

export abstract class SearchAsYouTypeDataProviderService extends BaseController {

    /**
     * This function should return an identifier for the concrete instance of this service. We need this because,
     * since this version of ngrx does not allow feature specific side effects we must load SearchAsYouTypeEffects from
     * the core module, and since SearchAsYouTypeEffects depends on SearchAsYouTypeDataProviderService we must also
     * provide it at app start. The problem with this is that SearchAsYouTypeEffects does not know which concrete
     * instance to use i.e. for jobs or email contacts. We handle this by dispatching an the
     * `ActionSetDataProviderServiceId` action containing the identifier which will allow SearchAsYouTypeEffects to grab
     * the correct instance to use for obtaining search results
     */
    abstract getIdentifier(): string;

    abstract getResults(searchValue: string): Observable<Array<SearchResultModel>>;

    abstract getResult(id: string): Observable<SearchResultModel>;
}



// WEBPACK FOOTER //
// ./src/app/atoms/search-as-you-type/search-as-you-type-data-provider.service.ts